import React, { useEffect } from "react";
import "../Styles/login.css";
import "../Styles/general.css";
import theme from "../Styles/theme";
import {
  Box,
  Button,
  Typography,
  ThemeProvider,
  CircularProgress,
  Toolbar,
} from "@mui/material";
import Header from "../Components/header";
import Footer from "../Components/footer";
import { useAuth } from "../Context/authContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useError } from "../Context/errorContext";

const config = require("../Config/config");

const Login = ({ loggedOut }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();
  const { setAlert } = useError();

  const params = new URLSearchParams(location.search);
  const redirectUrl = params.get("redirect") || "/";
  useEffect(() => {
    const error = params.get("error");
    if (error) setAlert({ severity: "error", message: error });
  }, []);

  useEffect(() => {
    if (!loading && user) {
      const savedRedirect = localStorage.getItem("postLoginRedirect") || "/";
      localStorage.removeItem("postLoginRedirect");
      navigate(savedRedirect, { replace: true });
    }
  }, [user, navigate, redirectUrl, loading]);

  if (user) return null;

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <Header />
        <Toolbar sx={{ height: "100px" }} />
        <Box className="loginContainer">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="50vh"
          >
            <CircularProgress />
          </Box>
          <Footer />
        </Box>
      </ThemeProvider>
    );
  }

  const handleLoginClick = () => {
    window.location.href = `${config.serverBaseUrl}/auth/azuread/login?redirect=${redirectUrl}`;
  };
  if (!loggedOut) {
    handleLoginClick();
    return null;
  }
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Header />
        <Toolbar sx={{ height: "100px" }} />
        <Box className="loginContainer">
          <Box className="loginOuterBox">
            <Box className="loginBox">
              <Typography variant="title" textAlign={"center"}>
                Login with your EBS account
              </Typography>
              <Button variant="login" onClick={handleLoginClick}>
                Login
              </Button>
            </Box>
          </Box>
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default Login;
